module.exports = __webpack_public_path__ + "img/kim_ocular.8f9e7ed1.jpg";